import FormSection from "~/components/formElements/FormSection";

import AddressFormFields from "./AddressFormFields";
import type { AddressFormFieldsData, AddressFormFieldsProps } from "./addressFormSectionTypes.ts";

const AddressFormSection = <T extends AddressFormFieldsData>(
	props: AddressFormFieldsProps<T>,
) => (
	<FormSection title="Adresse">
		<AddressFormFields {...props} />
	</FormSection>
);

export default AddressFormSection;